module.exports = __webpack_public_path__ + "static/media/dealing_card.13e6ac3f.mp3";